export default '6.26.0';